<template>

  <div class="w-full">
    <div class="flex justify-between w-full">

      <div class="text-xl font-semibold">
        Uživatelia v aplikácii
      </div>

    </div>

    <hr class="my-4">

    <DataTable :value="usersList" tableStyle="min-width: 50rem">
      <Column field="phone" header="Tel č."></Column>
      <Column field="user_metadata.nameAndUsername" header="Meno a priezvisko"></Column>
      <Column field="created_at" header="Registracia">
        <template #body="slotProps">
          <template v-if="slotProps?.data?.created_at">
            {{ parseIsoDate(slotProps.data.created_at) }}
          </template>
        </template>
      </Column>
      <Column field="phone_confirmed_at" header="Potrdenie sms">
        <template #body="slotProps">
          <template v-if="slotProps?.data?.phone_confirmed_at">
            {{ parseIsoDate(slotProps.data.phone_confirmed_at) }}
          </template>
        </template>
      </Column>
      <Column field="last_sign_in_at" header="Posledné prihlásenie">
        <template #body="slotProps">
          <template v-if="slotProps?.data?.last_sign_in_at">
            {{ parseIsoDate(slotProps.data.last_sign_in_at) }}
          </template>
        </template>
      </Column>
    </DataTable>

  </div>


</template>

<script setup>
import Supabase from "@/utils/Supabase";
import {ref} from 'vue'
import {RESTAURANT_PLACES} from "@/content/lists.js";
import {format, parseISO} from 'date-fns';

const usersList = ref([])
const loadUsers = async () => {

  const {data: {users}, error} = await Supabase.auth.admin.listUsers()

  if (error) {
    console.error('error', error)
    alert('Chyba pri načítaní používateľov')
    return
  }


  usersList.value = users

}

loadUsers()

const parseIsoDate = date => {
  const parsedDate = parseISO(date);
  return format(parsedDate, 'dd.MM.yyyy HH:mm');
}

</script>